export default "__VITE_ASSET__14c72bb5__"